import React from 'react';

import Css from './TextBox.scss';

const textBox = props => {
  const linkClass =
    props.link !== undefined && props.link.classNames !== undefined
      ? props.link.classNames
      : 'btn btn-default btn-block mt-3';

  const btnClass =
    props.button !== undefined && props.button.classNames !== undefined
      ? props.button.classNames
      : 'btn btn-default btn-block mt-3';

  return (
    <div className={Css['text-box']} style={props.style}>
      {props.header !== false && (
        <div className={Css.header}>
          {props.jsxHeader === undefined ? (
            props.isHeader !== undefined ? (
              <h1 dangerouslySetInnerHTML={{ __html: props.header }} />
            ) : (
              <div dangerouslySetInnerHTML={{ __html: props.header }} />
            )
          ) : (
            props.header
          )}
          <div className={Css['sub-header']}>{props.subHeader}</div>
        </div>
      )}

      <div className={Css.content}>
        <div dangerouslySetInnerHTML={{ __html: props.content }} />
        {props.children}
        {props.link !== undefined && (
          <a
            href={props.link.url}
            className={linkClass}
            target={props.link.target}
            onClick={props.link.onClick}
          >
            {props.link.label}
          </a>
        )}

        {props.button !== undefined && (
          <button onClick={props.button.click} className={btnClass}>
            {props.button.label}
          </button>
        )}
      </div>
    </div>
  );
};

export default textBox;



// WEBPACK FOOTER //
// ./src/components/TextBox/TextBox.js